import axios from '../axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: [],
    status: [
      { id: 0, name: 'De făcut', icon: 'check_box_outline_blank', color: 'red' },
      { id: 1, name: 'Făcut', icon: 'check_box', color: 'green' }
    ]
  },

  actions: {
    LOAD({ commit, state, rootGetters }, { filter }) {
      let params = {};
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/visit-actions`, { params: params })
          .then(response => response.data)
          .then(response => {
            commit('VISIT_ACTIONS', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/visit-actions/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit, rootState, rootGetters }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/visit-actions/${data.id}`, data)
          .then(response => response.data)
          .then(response => {
            response.data.path = rootGetters['actions/action'](response.data.action.id).path;
            commit('EDIT', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit, rootState, rootGetters }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${constants.SERVER_URL}/api/visit-actions`, data)
          .then(response => response.data)
          .then(response => {
            response.data.path = rootGetters['actions/action'](response.data.action.id).path;
            commit('ADD', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }

  },

  mutations: {
    VISIT_ACTIONS(state, payload) {
      state.data = payload;
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(item => item.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    statusById: (state) => {
      const objectById = {};
      state.status !== null && state.status.forEach(item => {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: (state, getters) => (id) => getters.statusById[id]
  }
};
